// extracted by mini-css-extract-plugin
export default {"active":"tab__active-Lqjt1","tab":"tab__tab-ZpJmV","error":"tab__error-JfFcK","success":"tab__success-fpS5C"};